const minutes = new Array(60).fill(1).map((i, idx) => idx);
const hours = new Array(24).fill(1).map((i, idx) => idx);

export default { minutes, hours };
export { minutes, hours };
